import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import { Link } from 'react-router-dom';
import { testimonials } from '@/mocks/homeData';
import { useEffect, useState } from 'react';

export default function AboutPage() {
  const [formStatus, setFormStatus] = useState<'idle' | 'success' | 'error'>('idle');
  const [formError, setFormError] = useState('');
  const [formSubmitting, setFormSubmitting] = useState(false);

  useEffect(() => {
    const aboutSchema = {
      "@context": "https://schema.org",
      "@type": "AboutPage",
      "name": "关于吃瓜网 - 品牌介绍与联系方式",
      "description": "吃瓜网是国内领先的娱乐八卦爆料平台，提供明星八卦、网红翻车、擦边内容聚合等服务。了解吃瓜网品牌故事、用户口碑与联系方式。",
      "about": { "@type": "Organization", "name": "吃瓜网", "url": "https://www.chiguawang.com" }
    };
    const breadcrumbSchema = {
      "@context": "https://schema.org",
      "@type": "BreadcrumbList",
      "itemListElement": [
        { "@type": "ListItem", "position": 1, "name": "首页", "item": "https://www.chiguawang.com" },
        { "@type": "ListItem", "position": 2, "name": "关于我们" }
      ]
    };
    const schemas = [
      { id: 'about-schema', data: aboutSchema },
      { id: 'breadcrumb-schema', data: breadcrumbSchema }
    ];
    schemas.forEach(({ id, data }) => {
      const script = document.createElement('script');
      script.type = 'application/ld+json';
      script.id = id;
      script.textContent = JSON.stringify(data);
      document.head.appendChild(script);
    });
    return () => {
      schemas.forEach(({ id }) => {
        const el = document.getElementById(id);
        if (el) el.remove();
      });
    };
  }, []);

  const handleSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    setFormSubmitting(true);
    setFormError('');

    const form = e.currentTarget;
    const formData = new FormData(form);

    // Honeypot check
    const honeypot = formData.get('contact_alt');
    if (honeypot && String(honeypot).trim() !== '') {
      setFormStatus('success');
      setFormSubmitting(false);
      form.reset();
      setTimeout(() => setFormStatus('idle'), 3000);
      return;
    }

    formData.delete('contact_alt');

    try {
      const response = await fetch('https://readdy.ai/api/form/d95mjjma5sk3luk4pg9g', {
        method: 'POST',
        headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
        body: new URLSearchParams(formData as any).toString(),
      });
      const responseText = await response.text();
      let parsed: any = {};
      try { parsed = JSON.parse(responseText); } catch { /* ignore parse errors */ }

      if (response.ok && parsed?.code === 'OK') {
        setFormStatus('success');
        form.reset();
      } else {
        const serverMsg = parsed?.meta?.message || parsed?.message || responseText;
        setFormError(serverMsg || '提交失败，请稍后重试');
        setFormStatus('error');
      }
    } catch {
      setFormError('网络错误，请稍后重试');
      setFormStatus('error');
    } finally {
      setFormSubmitting(false);
    }
  };

  return (
    <>
      <Navbar />
      <main className="pt-16 md:pt-18">
        {/* Page Header */}
        <section className="py-10 md:py-14 px-4 md:px-6 bg-background-100">
          <div className="max-w-7xl mx-auto">
            <nav className="flex items-center gap-2 text-xs text-foreground-400 mb-4" aria-label="面包屑导航">
              <Link to="/" className="hover:text-primary-500 transition-colors">首页</Link>
              <i className="ri-arrow-right-s-line"></i>
              <span className="text-foreground-700">关于我们</span>
            </nav>
            <h1 className="font-heading text-2xl md:text-3xl text-foreground-950">关于吃瓜网</h1>
            <p className="text-foreground-500 text-sm mt-2">八卦有理 · 吃瓜无罪</p>
          </div>
        </section>

        {/* Brand Story */}
        <section className="py-12 md:py-16 px-4 md:px-6 bg-background-50">
          <div className="max-w-7xl mx-auto">
            <div className="flex flex-col lg:flex-row gap-10 lg:gap-16 items-center">
              <div className="w-full lg:w-1/2">
                <div className="rounded-[2rem] overflow-hidden">
                  <img
                    src="https://readdy.ai/api/search-image?query=Warm%20modern%20creative%20office%20space%20with%20large%20windows%20and%20natural%20light%2C%20collaborative%20workspace%20with%20minimal%20furniture%2C%20indoor%20plants%2C%20warm%20beige%20and%20cream%20interior%2C%20creative%20atmosphere%2C%20editorial%20photography%2C%20high%20quality%2C%20clean%20professional%20aesthetic%2C%20no%20people&width=800&height=600&seq=gossip-about-story&orientation=landscape"
                    alt="吃瓜网品牌故事"
                    className="w-full h-auto"
                  />
                </div>
              </div>
              <div className="w-full lg:w-1/2">
                <h2 className="font-heading text-2xl md:text-3xl text-foreground-950 mb-4">品牌故事</h2>
                <div className="space-y-4 text-foreground-600 text-sm leading-relaxed">
                  <p>吃瓜网成立于2023年，由一群热爱娱乐八卦的互联网人创立。我们深知"吃瓜"是当代年轻人不可或缺的社交货币，于是决定打造一个专业、快速、真实的爆料聚合平台。</p>
                  <p>从最初的几个人运营到现在数百万日活用户，吃瓜网始终秉持"八卦有理，吃瓜无罪"的核心理念。我们不生产八卦，我们只是瓜田的搬运工——每一条爆料都经过严格审核，确保信息的真实性和可靠性。</p>
                  <p>如今，吃瓜网已成为国内领先的娱乐资讯平台，覆盖明星八卦、网红翻车、综艺黑幕、行业爆料等多个领域。我们的用户遍布全国，日均产生数万条互动评论。</p>
                  <p>未来，吃瓜网将继续深耕娱乐爆料领域，用技术驱动内容质量，为亿万吃瓜群众提供更好的服务。</p>
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* Stats */}
        <section className="py-12 md:py-16 px-4 md:px-6 bg-background-100">
          <div className="max-w-7xl mx-auto">
            <div className="grid grid-cols-2 md:grid-cols-4 gap-6 md:gap-8">
              {[
                { value: '580万+', label: '月活跃用户' },
                { value: '12,860+', label: '明星八卦爆料' },
                { value: '9,540+', label: '网红翻车实锤' },
                { value: '99.7%', label: '用户满意度' },
              ].map((stat) => (
                <div key={stat.label} className="text-center">
                  <p className="font-heading text-2xl md:text-3xl text-primary-500 font-bold">{stat.value}</p>
                  <p className="text-foreground-500 text-xs md:text-sm mt-2">{stat.label}</p>
                </div>
              ))}
            </div>
          </div>
        </section>

        {/* Reputation / Testimonials */}
        <section className="py-12 md:py-16 px-4 md:px-6 bg-background-50">
          <div className="max-w-7xl mx-auto">
            <div className="text-center mb-8 md:mb-10">
              <h2 className="font-heading text-2xl md:text-3xl text-foreground-950">用户口碑</h2>
              <p className="text-foreground-500 text-sm mt-2">看看吃瓜群众怎么说</p>
            </div>
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-5">
              {testimonials.slice(0, 3).map((t) => (
                <div key={t.id} className="bg-background-50 rounded-2xl border border-secondary-200/60 p-5 md:p-6">
                  <i className="ri-double-quotes-l text-3xl text-accent-200"></i>
                  <p className="text-foreground-600 text-sm leading-relaxed mt-2 mb-5">{t.quote}</p>
                  <div className="flex items-center gap-3 pt-3 border-t border-secondary-200/50">
                    <img src={t.avatar} alt={t.name} className="w-9 h-9 rounded-full object-cover" />
                    <div>
                      <p className="text-foreground-900 text-sm font-semibold font-heading">{t.name}</p>
                      <p className="text-foreground-400 text-xs">{t.role}</p>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </section>

        {/* Business Cooperation */}
        <section className="py-12 md:py-16 px-4 md:px-6 bg-background-100">
          <div className="max-w-7xl mx-auto">
            <div className="text-center mb-8 md:mb-10">
              <span className="inline-block px-3 py-1 rounded-full bg-accent-100 text-accent-700 text-xs font-semibold mb-3">
                🤝 商务合作
              </span>
              <h2 className="font-heading text-2xl md:text-3xl text-foreground-950">合作共赢</h2>
              <p className="text-foreground-500 text-sm mt-2">开放多种合作模式，期待与你携手共创</p>
            </div>
            <div className="grid grid-cols-1 md:grid-cols-3 gap-4 md:gap-5">
              {[
                {
                  icon: 'ri-advertisement-line',
                  title: '广告投放',
                  desc: '提供首页轮播、分类置顶、文章内嵌等多种广告位选择，精准触达数百万吃瓜用户群体。',
                  color: 'bg-primary-100',
                  iconColor: 'text-primary-500',
                },
                {
                  icon: 'ri-shake-hands-line',
                  title: '内容合作',
                  desc: '欢迎自媒体、MCN机构、娱乐平台进行内容互换与联合报道，共享流量红利。',
                  color: 'bg-accent-100',
                  iconColor: 'text-accent-600',
                },
                {
                  icon: 'ri-briefcase-line',
                  title: '品牌入驻',
                  desc: '为品牌提供官方发声渠道，在爆料事件中快速响应、发布官方声明与澄清信息。',
                  color: 'bg-secondary-200',
                  iconColor: 'text-secondary-600',
                },
              ].map((coop) => (
                <div key={coop.title} className="bg-background-50 rounded-2xl border border-secondary-200/60 p-6 md:p-7 text-center hover:border-primary-200 transition-all duration-300">
                  <div className={`w-12 h-12 mx-auto rounded-xl ${coop.color} flex items-center justify-center mb-4`}>
                    <i className={`${coop.icon} text-xl ${coop.iconColor}`}></i>
                  </div>
                  <h3 className="font-heading text-lg text-foreground-900 mb-2">{coop.title}</h3>
                  <p className="text-foreground-500 text-sm leading-relaxed">{coop.desc}</p>
                </div>
              ))}
            </div>
          </div>
        </section>

        {/* Contact Form */}
        <section className="py-12 md:py-16 px-4 md:px-6 bg-background-100">
          <div className="max-w-2xl mx-auto">
            <div className="text-center mb-8">
              <h2 className="font-heading text-2xl md:text-3xl text-foreground-950">联系我们</h2>
              <p className="text-foreground-500 text-sm mt-2">有任何爆料线索或合作意向，欢迎联系我们</p>
            </div>

            {/* Status Messages */}
            {formStatus === 'success' && (
              <div className="mb-6 p-4 rounded-xl bg-accent-100 text-accent-700 text-sm">
                <i className="ri-check-line mr-2"></i> 提交成功！我们会尽快与您联系。
              </div>
            )}
            {formStatus === 'error' && (
              <div className="mb-6 p-4 rounded-xl bg-primary-100 text-primary-700 text-sm">
                <i className="ri-error-warning-line mr-2"></i> {formError}
              </div>
            )}

            <form onSubmit={handleSubmit} className="space-y-5" data-readdy-form="">
              <div className="grid grid-cols-1 sm:grid-cols-2 gap-5">
                <div>
                  <label htmlFor="name" className="block text-foreground-700 text-sm font-medium mb-2">姓名</label>
                  <input
                    type="text"
                    id="name"
                    name="name"
                    required
                    className="w-full px-4 py-3 rounded-xl border border-secondary-300 bg-background-50 text-foreground-900 text-sm focus:outline-none focus:border-primary-400 transition-colors"
                    placeholder="请输入您的姓名"
                  />
                </div>
                <div>
                  <label htmlFor="email" className="block text-foreground-700 text-sm font-medium mb-2">邮箱</label>
                  <input
                    type="email"
                    id="email"
                    name="email"
                    required
                    className="w-full px-4 py-3 rounded-xl border border-secondary-300 bg-background-50 text-foreground-900 text-sm focus:outline-none focus:border-primary-400 transition-colors"
                    placeholder="请输入您的邮箱"
                  />
                </div>
              </div>
              <div>
                <label htmlFor="subject" className="block text-foreground-700 text-sm font-medium mb-2">主题</label>
                <input
                  type="text"
                  id="subject"
                  name="subject"
                  required
                  className="w-full px-4 py-3 rounded-xl border border-secondary-300 bg-background-50 text-foreground-900 text-sm focus:outline-none focus:border-primary-400 transition-colors"
                  placeholder="请输入主题"
                />
              </div>
              <div>
                <label htmlFor="message" className="block text-foreground-700 text-sm font-medium mb-2">留言内容</label>
                <textarea
                  id="message"
                  name="message"
                  required
                  rows={5}
                  maxLength={500}
                  className="w-full px-4 py-3 rounded-xl border border-secondary-300 bg-background-50 text-foreground-900 text-sm focus:outline-none focus:border-primary-400 transition-colors resize-none"
                  placeholder="请输入您的留言内容（最多500字）"
                ></textarea>
              </div>
              {/* Honeypot */}
              <div className="contact-alt-wrap">
                <input type="text" name="contact_alt" tabIndex={-1} autoComplete="off" aria-hidden="true" readOnly />
              </div>
              <button
                type="submit"
                disabled={formSubmitting}
                className="whitespace-nowrap w-full py-3.5 rounded-full bg-primary-500 text-white font-semibold text-sm hover:bg-primary-600 transition-colors disabled:opacity-50 cursor-pointer"
              >
                {formSubmitting ? '提交中...' : '发送留言'}
              </button>
            </form>

            {/* Contact Info */}
            <div className="mt-10 grid grid-cols-1 sm:grid-cols-3 gap-4">
              {[
                { icon: 'ri-mail-line', label: '商务合作', value: 'biz@chiguawang.com' },
                { icon: 'ri-wechat-line', label: '官方微信', value: 'chiguawang_official' },
                { icon: 'ri-map-pin-line', label: '公司地址', value: '北京市朝阳区建国路88号SOHO现代城A座' },
              ].map((info) => (
                <div key={info.label} className="text-center p-4 rounded-xl bg-background-50 border border-secondary-200/60">
                  <i className={`${info.icon} text-2xl text-primary-500 mb-2 block`}></i>
                  <p className="text-foreground-400 text-xs mb-1">{info.label}</p>
                  <p className="text-foreground-800 text-sm font-medium">{info.value}</p>
                </div>
              ))}
            </div>
          </div>
        </section>
      </main>
      <Footer />
    </>
  );
}